import React, { useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles from "./modifier.module.css";
import styles1 from "../Category/category.module.css";
import CategoryModal from "../../../Components/Modals/MenuCategoryModal/CategoryModal";
import { CiSearch } from "react-icons/ci";
import { useFetchAll } from "../../../custom/FetchApiHook";
import MenuApi from "../../../App/api/menu.apis";

const ModifierCategory = ({meta}) => {
  const [changeStore, setChangeStore] = useState(false);
  const [modifierCategoryData, setModifierCategoryData] = useState();

  const { value: allModifierCategory } = useFetchAll(() =>
    MenuApi.modifier.getAllModifierCategory()
  );

  const getAllModifier = async (venderId) => {
    // console.log("searchVenderCategory", venderId);
    try {
      const res = await MenuApi.modifier.getAllModifierCategory(venderId);
      // console.log("res");
      setModifierCategoryData(res.data?.data?.modifierCategory);
    } catch (error) {
      // console.log("error", error);
    }
  };

  // console.log(
  //   "allModifierCategory",
  //   allModifierCategory?.data?.modifierCategory
  // );
  const modiefierCategoryData =
    modifierCategoryData || allModifierCategory?.data?.modifierCategory;

  return (
    <>
      <CommonLayout />
      <div className={`${styles1.subcatcontainer} ${styles.container}`}>
        <div className={styles1.top_content}>
          <div>
            <p className={styles1.p1}>
              Demo Rajesh <span className={styles1.span1}>(Bilaspur)</span>
            </p>
            <div className={styles1.border_search}>
              <input
                type="text"
                style={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                }}
                // className={styles1.border_search}
                placeholder="Search"
              />
              <CiSearch size={"1.1rem"} />
            </div>
          </div>

          <p className={styles1.p2_border} onClick={() => setChangeStore(true)}>
            Change Store
          </p>
        </div>
        <hr style={{ marginTop: "1.3rem" }} />
        <div className={styles.items__container}>
          {modiefierCategoryData?.map((item, index) => (
            <div key={index} style={{ padding: "1rem" }}>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    width: "1rem",
                    height: "1rem",
                    borderRadius: "50%",
                    border: "2px solid green",
                  }}
                ></div>
                <p className={styles.p_header}>{item.name}</p>
              </div>
              <div
                className={styles.p__text}
                style={{ display: "flex", gap: "10px" }}
              >
                {item.modifier.map((modifier, modIndex) => (
                  <div key={modIndex} style={{ display: "flex", gap: "10px" }}>
                    <p className={styles.modifier}>{modifier.name}</p>
                    <p style={{ color: "green" }}>
                      ₹ {modifier?.price?.$numberDecimal}
                    </p>
                    {item.modifier.length > 1 &&
                      modIndex !== item.modifier.length - 1 && <p>|</p>}
                  </div>
                ))}
              </div>
              {index !== modiefierCategoryData.length - 1 && (
                <hr style={{ marginTop: "1rem" }} />
              )}
            </div>
          ))}
        </div>
      </div>
      {changeStore && (
        <CategoryModal
          setChangeStore={setChangeStore}
          getAllVendorCategory={getAllModifier}
        />
      )}
    </>
  );
};

export default ModifierCategory;
